// removed by extract-text-webpack-plugin
module.exports = {"dotContainer":"IxXpg-P","dotItem":"_2dX_dN9","dot":"_1ooe7Gy","dot__selected":"_1rTNrrq"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css
// module chunks = client.sitechrome